<script setup>
const currentDate = new Date().getFullYear()
</script>

<template>
  <footer class="footer has-text-centered content has-background-text-25 has-text-primary-25-invert">
    <p>
      <b>Questions, comments or ideas for this database?
        <a class="linkDarkTheme" href="mailto:stopacademiccomplicity@proton.me">Contact us!</a>
      </b>
    </p>

    <p>
      <b>Content</b>: <a  class="linkDarkTheme" href="https://stopwapenhandel.org/" target="_blank">Stop Wapenhandel</a> and Stop academic complicity, supported by a team of volunteers.
      <br>
      <b>Website design</b>: <a  class="linkDarkTheme" href="https://solid-sustainability.org" target="_blank">Solid Sustainability Research</a> and volunteer contributors © {{currentDate}}</p>
  </footer>
</template>

<style scoped>
footer a {
  color: white;
  text-decoration: underline;
}
</style>
